<template>
  <v-row @click="emits('click')" dense >
    <v-col v-if="label" cols="12" class="font-weight-bold">
      <v-icon v-if="icon" class="mr-2" size="small" color="primary" :icon="icon" data-pw="displayIcon"/>
      {{ label }}
    </v-col>
    <v-col v-if="value" cols="12">
      {{ value }}
    </v-col>
    <v-col v-if="$slots.value">
      <slot name="value" />
    </v-col>
    <v-col v-if="!value && !$slots.value" cols="12">
      <span class="text-grey font-weight-bold">None</span>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import {PropType} from "vue";

const emits = defineEmits(["click"]);

defineProps({
  label: {
    type: String as PropType<string>,
    required: true
  },
  icon: {
    type: String as PropType<string>,
  },
  value: {
    type: [String, Boolean] as PropType<string | boolean>,
  },
});
</script>
